export default __webpack_public_path__ + "static/media/4_fooddiary__november.12e03d55.jpg";